import { ReactNode, useState } from "react"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"
import DashboardTopbar from "@/components/DashboardTopbar"
import ImportExportGamesDropdown from "@/components/ImportExportGamesDropdown"
import { PlusIcon, ChevronDownIcon } from "@heroicons/react/20/solid"
import AppLayout from "@/layouts/AppLayout"
import GamesList from "@/components/GamesList"
import useCreateGame from "@/hooks/useCreateGame"
import ImportModal from "@/modals/ImportModal"
import PositionBuilder from "@/components/game/PositionBuilder"
import clsx from "clsx"

const GamesIndex = () => {
  const { createGame, processing } = useCreateGame()
  const [showPositionBuilder, setShowPositionBuilder] = useState(false)

  if (showPositionBuilder) {
    return (
      <PositionBuilder
        onComplete={(fen) => {
          setShowPositionBuilder(false)
          createGame({ chess960: true, start: fen })
        }}
        onCancel={() => setShowPositionBuilder(false)}
      />
    )
  }

  return (
    <>
      <DashboardTopbar title="Games">
        <ImportExportGamesDropdown />
        <div className="relative inline-flex">
          <button
            onClick={() => createGame()}
            disabled={processing}
            className="focus-visible:outline-chessdrop-500 inline-flex h-9 items-center gap-x-1 rounded-l-xl border border-chessdrop-500 bg-chessdrop-500 px-3 text-sm font-semibold text-white shadow-xs hover:bg-chessdrop-600 focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-50"
          >
            <PlusIcon className="h-5 w-5" />
            <span>Add game</span>
          </button>
          <Menu as="div" className="relative">
            <MenuButton
              className="focus-visible:outline-chessdrop-500 inline-flex h-9 items-center rounded-r-xl border border-l-0 border-chessdrop-500 bg-chessdrop-500 px-2.5 text-white/90 shadow-xs hover:bg-chessdrop-600 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 before:absolute before:left-0 before:top-1.5 before:bottom-1.5 before:w-px before:bg-white/25"
            >
              <ChevronDownIcon className="ui-open:rotate-180 h-5 w-5 transition-transform duration-100" />
            </MenuButton>
            <MenuItems
              transition
              className={clsx([
                "absolute right-0 z-10 mt-2 w-48 origin-top-right overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none",
                "data-closed:scale-95 data-closed:opacity-0",
                "data-enter:duration-100 data-enter:ease-out",
                "data-leave:duration-75 data-leave:ease-in",
              ])}
            >
              <div className="py-2">
                <MenuItem>
                  <button
                    onClick={() => setShowPositionBuilder(true)}
                    className="block w-full px-4 py-3 text-left text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900"
                  >
                    <span className="font-medium">Freestyle</span>
                    <span className="mt-0.5 block text-xs text-gray-400">
                      Custom starting position
                    </span>
                  </button>
                </MenuItem>
              </div>
            </MenuItems>
          </Menu>
        </div>
      </DashboardTopbar>

      <GamesList />

      <ImportModal />
    </>
  )
}

GamesIndex.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>

export default GamesIndex
